import VideoCallModal from "./video-call-modal";

export default VideoCallModal;